app.controller('studentWelcome3CtrlOrig', [
    '$scope', '$interval', 'gameService', '$state', function ($scope, $interval, gameService, $state) {

        var vm = this;

        vm.timeRemainingSecs = 84010; // 23h, 20m, 10s
        vm.showPlaceHolder = true;
        vm.canProceed = gameService.config.allowSkipIntroMovie;
        vm.skipPercentage = gameService.config.introMoviePassPercentage;

        vm.updateClockDisplay = function() {
            var trs = vm.timeRemainingSecs;
           
            var hr = parseInt(Math.floor(trs / 3600));
            trs -= (hr * 3600);

            var mr = parseInt(Math.floor(trs / 60));
            trs -= (mr * 60);
            
            vm.daysRemain = Math.floor(hr / 24.0);
            vm.hoursRemain = hr;
            vm.minutesRemain = mr;
            vm.secondsRemain = trs;
        }

        vm.updateClockDisplay();

        vm.countdownId = $interval(function() {
            vm.timeRemainingSecs -= 1;
            vm.updateClockDisplay();
        }, 1000);

        $scope.$on('$destroy', function() {
            $interval.cancel(vm.countdownId);
        });

        vm.isPlaying = false;
        vm.playVideo = function() {
            var video = $(".w3video")[0];
            if (vm.showPlaceHolder) {
                vm.showPlaceHolder = false;
                video.play();
                video.addEventListener("timeupdate", vm.onVideoTimeUpdated);
                vm.isPlaying = true;
            } else {
                if (vm.isPlaying) {
                    video.pause();
                    vm.isPlaying = false;
                } else {
                    video.play();
                    vm.isPlaying = true;
                }
            }
        }

        vm.onVideoTimeUpdated = function(event) {
            var percentage = Math.floor((100 / event.target.duration) * event.target.currentTime);
            if (percentage >= (vm.skipPercentage * 100.0) && !vm.canProceed) {
                vm.canProceed = true;
            }
        }

        vm.onCanProceedChanged = function() {
            if (!vm.canProceed) {
                $scope.$parent.enabledPages[2] = false;
            } else {
                $scope.$parent.enabledPages[2] = true;
            }
        }

        $scope.$watch('vm.canProceed', angular.bind(vm, function() {
            vm.onCanProceedChanged();
        }));

        vm.prev = function() {
            $scope.$parent.prevPage();
        }

        vm.next = function() {
            var video = $(".w3video")[0];
            video.pause();
            $scope.$parent.nextPage();
        }
   }
]);